
import { Observer } from 'mobx-vue'
import { Vue, Component } from 'vue-property-decorator'
import OrderItem from './views/item/item.vue'
import OrderListScript from './script'
import Teleport from '@xt/client/mixins/components/teleport.vue'
import InfiniteLoading from '@xt/www/components/infinite-loadingv2/index.vue'

@Observer
@Component({
  components: {
    OrderItem, // 订单卡片
    Teleport,
    InfiniteLoading
  }
})
export default class OrderListComp extends OrderListScript {}
